module.exports = __webpack_public_path__ + "img/mft.f6a5c66e.svg";